import { render, staticRenderFns } from "./ProductModelIndex.vue?vue&type=template&id=381a0b12&"
import script from "./ProductModelIndex.vue?vue&type=script&lang=js&"
export * from "./ProductModelIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports